var map = {
	"./Aghani Aghani logo.jpg": 212,
	"./Arts and melon.jpeg": 2937,
	"./Atlantis the Royal.jpg": 4296,
	"./BERKLEE Bilingual.png": 8566,
	"./BTOS.jpg": 3742,
	"./Benchmark.png": 8241,
	"./DOLBY.jpg": 651,
	"./Disney.jpg": 6253,
	"./JMR STUDIOS.png": 8671,
	"./Janssen-logo-web.jpg": 3523,
	"./LBCI.jpg": 1714,
	"./MBC.jpng.png": 7301,
	"./MDLBeast-Records.jpeg": 694,
	"./MTV LEB.png": 2289,
	"./Music Or Media Holdings.png": 3137,
	"./MusicHall logo.jpg": 503,
	"./Netflix-logo-red-black-png.png": 5282,
	"./Nostalgie Radio.jpg": 7351,
	"./Nrj Radio.png": 4650,
	"./O By Michel Fadel.png.jpeg": 1457,
	"./Parkwood Logo 1.jpeg": 8903,
	"./Parkwood Logo 2.png": 6719,
	"./SIXIEME_SON_LOGO_RVB.png.webp": 7514,
	"./aldar-properties-logo-vector.png": 6620,
	"./anghami-logo.png": 202,
	"./expo 2020 dubai.jpg": 7942,
	"./expo city dubai.webp": 2705,
	"./flash-entertainment.jpg": 6518,
	"./mdlbeast-.png.jpeg": 8925,
	"./redbull music.jpg": 4247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2534;